import { EventCardSkeleton } from '../EventCard';

interface EventsColumnSkeletonProps {
  /**
   * Column title to display
   */
  title?: string;
  /**
   * Number of skeleton cards to display (defaults to 3)
   */
  cardCount?: number;
  /**
   * Whether to show the toggle chevron skeleton
   */
  showToggle?: boolean;
}

export function EventsColumnSkeleton({
  title,
  cardCount = 3,
  showToggle = false,
}: EventsColumnSkeletonProps) {
  return (
    <div className="h-full flex flex-col rounded-lg overflow-hidden">
      {/* Column Header Skeleton */}
      <div className="flex items-center justify-between p-2 ps-4">
        <div className="flex items-center space-x-2">
          {showToggle && (
            <div className="h-4 w-4 bg-gray-200 rounded animate-pulse" />
          )}
          {title ? (
            <h2 className="font-semibold text-gray-900">{title}</h2>
          ) : (
            <div className="h-5 bg-gray-200 rounded animate-pulse w-24" />
          )}
        </div>
      </div>

      {/* Events List Skeleton */}
      <div className="flex-1 overflow-y-auto space-y-0">
        {Array.from({ length: cardCount }).map((_, index) => (
          <EventCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
